



























































import {Component, Mixins} from 'vue-property-decorator';
import EditDialog from '@/components/EditDialog.vue';
import EditDialogMixin from '@/mixins/EditDialogMixins';
import SelectDialogField from '@c/controls/selectControls/SelectDialogField.vue';
import pmoduleStoreModule from '@/store/modules/entities/pmodules/pmoduleModule';
import enumsModule from '@/store/modules/enumsModule';
import {httpClient} from '@/api/baseApi';
import {EventDefaultValues} from '@/views/system/measurements/interfaces';

@Component({
  components: {EditDialog, SelectDialogField},
})
export default class PModuleHeaterMonitorConditionEditDialog extends Mixins(EditDialogMixin) {
  nonEmptyTextRule = (v: any) => !!v || (v && v.length === 0) || 'Поле обязательно для заполнения';

  get conditionTypes() {
    return ['=', '>', '>=', '<', '<=', 'max=', 'max>', 'max>=', 'max<', 'max<='];
  }

  // все экземпляры модулей
  modules = [...pmoduleStoreModule.all];

  // настройки выбранного модуля
  moduleDefaultValues: EventDefaultValues[] = [];

  async created() {
    await pmoduleStoreModule.fetchAll();
    this.modules = [...pmoduleStoreModule.all];
  }

  /// представление всех экземпляров модулей
  get modulesNames() {
    this.moduleDefaultValues = [];
    return this.modules.map(x => ({
      type: x.type,
      guid: x.guid,
      name: x.name,
    }));
  }

  get eventTypeNames() {
    if (this.moduleDefaultValues.length === 0 && this.data.module_id) {
      this.getDefaultValues();
    }
    return this.moduleDefaultValues
      ? this.moduleDefaultValues.map(v => ({description: v.description, type: v.type}))
      : null;
  }

  get aliasTypeNames() {
    const aliasTypes = this.moduleDefaultValues.filter(v => v.type === this.data.message_type);
    return aliasTypes.length > 0
      ? aliasTypes[0].fields.map(v => ({description: v.description, type: v.alias}))
      : [];
  }

  onEventTypeChange() {
    this.data.field_name = '';
  }

  async onModuleTypeChange() {
    // очистка зависимых данных
    this.data.message_type = '';
    // получение дефолтных значений
    this.getDefaultValues();
  }

  async getDefaultValues() {
    const type = this.modules.filter(v => v.guid === this.data.module_id);
    const currentModuleType = enumsModule.moduleTypes.filter(v => v.value === type[0].type);
    const moduleParametersResponse: {data: any} = await httpClient.get(
      `${currentModuleType[0].url}/events/event_types`,
    );
    this.moduleDefaultValues = moduleParametersResponse.data;
  }
}
